import React, { useState } from "react";
import PageTitleSection from "components/common/PageTitleSection";
import TabsContainer from "components/common/TabsContainer";
import ComponentsForecast from "./ComponentsForecast";
import FinishedGoodsForecast from "./FinishedGoodsForecast";

const Forecast = () => {
    const [activeTab, setActiveTab] = useState<number>(0);

    const forecastFactors = [
        {
            title: "Seasonality",
            description: "Recurring purchase patterns across time periods.",
        },
        {
            title: "Historical Sales",
            description: "Uses past sales data to identify patterns and trends.",
        },
        {
            title: "Trends",
            description: "Long-term shifts in demand behavior.",
        },
        {
            title: "Recent Sales Velocity",
            description: "The speed at which products are selling.",
        },
        {
            title: "Calendar Seasons",
            description: "Demand patterns by Winter, Spring, Summer, and Autumn.",
        },
    ];

    const tabs = [
        {
            title: "Finished goods",
            component: <FinishedGoodsForecast />,
        },
        {
            title: "Components forecast",
            component: <ComponentsForecast />,
        },
    ];

    return (
        <div>
            <div className="mb-6">
                <PageTitleSection
                    leftComp={<h3 className="text-xl text-g-75 font-rocGroteskMedium">Forecast</h3>}
                />
            </div>

            <div>
                <TabsContainer
                    tabs={tabs.map((tab) => tab.title)}
                    activeTab={activeTab}
                    setActiveTab={(idx) => {
                        setActiveTab(idx);
                    }}
                    component={tabs[activeTab].component}
                    className="!px-0"
                    itemClassName="!pb-2"
                    borderLineClase={"!text-slate-100 w-full max-lg:w-full mb-6"}
                    tabRowClassname="!overflow-visible"
                />
            </div>

            <div className="mt-4 ">
                <h3 className="text-sm font-rocGroteskMedium mb-4">Forecasting factors</h3>

                <div className="grid grid-cols-5 gap-[18px]">
                    {forecastFactors.map((factor, idx) => (
                        <div
                            key={idx}
                            className="bg-slate-50 border border-slate-100 rounded-lg p-[15px]"
                        >
                            <h4 className="text-base text-slate-600 font-rocGroteskMedium mb-1">
                                {factor.title}
                            </h4>
                            <p className="text-xs text-slate-500 font-rocGroteskMedium">
                                {factor.description}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Forecast;
